<template>
  <div class="main-container">
    <!-- Author: Bhushan
      Date: 09/02/2021
      Description: IT Proof Submisssion component-->
    <!--  <breadcrumb :list="breadcrumbList" />  -->
    <div class="model" v-if="it_proof_download">
      <span class="loader"></span>
      <span>Loading...........</span>
    </div>
    <div class="margintop-16" />
    <tl-header type="h1">Income Proof Submission</tl-header>
    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission..
    </div>
    <div class="lineheight" :disabled="!ifTeamleaderAnchorPermission">
      <!-- Search box and upload button add here -->
                <div >
                    <div class="float-right">
                        <span style="cursor:pointer" @click="downloadItProofDetails" >
                            <img class="search-icon-filter" src="@/assets/download.svg" style="width: 30px;height: 34px;" alt /> <span class="filter-text">Download IT Proof Details</span>
                        </span>
                        <span style="cursor:pointer; margin-left: 20px;" @click="downloadItSubmissionDetails">
                            <img class="search-icon-filter" src="@/assets/download.svg"  style="width: 30px;height: 34px;" alt /> <span class="filter-text">Download IT Submission Status</span>
                        </span>
                    </div>
                </div>
      <div class="selectdiv my-3">
        <div class="row">
          <div class="col-4">
            <div class="search-container">
              <tl-search
                @change="filterData($event)"
                @blur="filterOnblur($event)"
                :placeholder="'Search Employee Name'"
              />
            </div>
          </div>
          <!-- <div class="col-4">
          <a class="anchor-underline-none show-filter-block" href="#"
            ><img class="search-icon-filter" src="@/assets/filter.png" alt="" />
            <span class="filter-text">Show Filter</span></a
          >
        </div> -->
          <div class="col-4"></div>
        </div>
      </div>
      <!-- End Code -->

      <!-- <div>{{employeeData.length}}&nbsp;/&nbsp;{{totalEmployees}}</div> -->
      <div>{{ employeeData.length }}&nbsp;/&nbsp;{{ employeeData.length }}</div>
      <div class="table-div" ref="table_div" @scroll="onScroll()">
        <data-table
          :columns="employeeTableColumns"
          :tableData="employeeData"
          :showinrow="true"
          :with-form="false"
          :showhistory="false"
          :showdelete="false"
          @editStart="navigateToIncomeTax"
        ></data-table>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  props: {},
  components: {},
  data() {
    return {
      it_proof_download: false,
      currentObj: {},
      popupType: "ConfirmDelete",
      showConfirmDelete: false,
      toast: false,
      errmsg: "",
      page: 1,
      totalEmployees: 0,
      locationList: [],
      designationList: [],
      employeeData: [],
      employeeTableColumns: [
        {
          label: "Code",
          key: "code",
        },
        {
          label: "Employee Name",
          key: "name",
        },
        {
          label: "Locations",
          key: "location",
        },
        {
          label: "Total Investment",
          key: "designation",
        },
        {
          label: "Last Modified On",
          key: "modify_at",
        },
      ],
      tempArrayList: [],
      itProofSubmissionValue: false,
      role: "",
    };
  },
  activated() {
    this.page = 1;
    this.toast = false;
    this.employeeData = [];
    this.getLocations();
    //this.getDesignation();
    this.fetchemp();
    this.getOrgLeIdList();
  },
  // PL_2989
  mounted() {
    this.toast = false;
    this.employeeData = [];
    this.fetchemp();
    this.getLocations();
    this.getOrgLeIdList();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),

    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },

    ...mapState("onboard/organization", {
      orgIds: (state) => state.id,
    }),
    ...mapState({
      payrollYear: state => state.payroll.runpayroll.payrollYear,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth
    }),
    ifTeamleaderAnchorPermission() {
      if (
        this.role === "TEAMLEADER" ||
        this.role === "ANCHOR" || 
        this.role === 'ADMIN'
      ) {
        if (this.itProofSubmissionValue) {
          return true;
        } else {
          return false;
        }
      } 
      // else {
      //   return true;
      // }
    },
  },
  methods: {
    ...mapActions({
      act_fetch: "onboard/employees/fetchAll",
      fetchLocations: "onboard/locations/fetchAll",
      act_download_it_submission_template: "dashboard/payroll/incometax/downloadItSubmissionDetails",
      act_download_it_proof_template: "dashboard/payroll/incometax/downloadItProofSubmittedDetails",

    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /* server call to get locations for current Legal Entity */
    async getLocations() {
      try {
        let res = await this.fetchLocations(this.le_id);
        if (res.data.status) {
          this.locationList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* server call to get Employees for current Legal Entity */
    async fetchemp() {
      try {
        let res = await this.act_fetch({ le_id: this.le_id, page: this.page });
        //console.log("IT PRoof", res);
        if (res.data.status) {
          let empList = [];
          this.totalEmployees = res.data.payload.totalEmpCount;
          res.data.payload.data.forEach((element) => {
            empList.push({
              id: element.id,
              name:
                element.first_name +
                " " +
                (element.last_name ? element.last_name : ""),
              code: element.code,
              modify_at:new Date(element.updated_at).toLocaleDateString("en-GB").replace(/\//g, '-'),
              location: element.EmployeeOfficial
                ? this.getLocationName(element)
                : "",
            });
          });
          this.employeeData = [...empList];
          this.tempArrayList = [...empList];
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /* function to get Employees on scroll */
    onScroll() {
      let bottomOfWindow =
        this.$refs.table_div.scrollHeight - this.$refs.table_div.scrollTop <=
        this.$refs.table_div.offsetHeight;
      if (bottomOfWindow && this.employeeData.length < this.totalEmployees) {
        this.page += 1;
        this.fetchemp();
      }
    },
    /* function to get location name based on location id */
    getLocationName(element) {
      let location = this.locationList.find((item) => {
        if (!element.EmployeeOfficial) return false;
        else return item.id == element.EmployeeOfficial.based_location_id;
      });
      return location ? location.name : "";
    },
    /* function to income tax dashboard */
    navigateToIncomeTax(rec) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxproofplan`,
        //path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax/incometaxdeclarationdashboard`,
        query: { id: rec.id },
      });
    },
  async downloadItSubmissionDetails(){
      try {
      this.it_proof_download = true;
      let payload = {
        le_id: this.le_id,
        financial_year: this.calculateFinancialYear()
      }
       let res = await this.act_download_it_submission_template(payload);
       this.it_proof_download = false
     } catch (error) {
      this.it_proof_download = false
    window.alert("Please try again after some time")
       
     }
    },
    calculateFinancialYear() {
      
      if (this.payrollMonth === 'January' || this.payrollMonth === 'February' || this.payrollMonth === 'March') {
          return this.payrollYear - 1;
      }
      else{
        return this.payrollYear;
      }
      },
      async downloadItProofDetails(){
      try {
      this.it_proof_download = true;
      let payload = {
        le_id: this.le_id,
        financial_year:this.calculateFinancialYear()
      }
       let res = await this.act_download_it_proof_template(payload);
       this.it_proof_download = false
     } catch (error) {
      this.it_proof_download = false
    window.alert("Please try again after some time")
       
     }
    },
    /* function to search in local by name */
    filterData(val) {
      try {
        let tempArray = [];
        this.tempArrayList.forEach((element) => {
          if (element.name) {
            if (element.name.toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
          if (element.code) {
            if (element.code.toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
        });
        if (val) {
          this.employeeData = tempArray;
        } else {
          this.employeeData = [...this.tempArrayList];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    filterOnblur(val){
      try {
        let tempArray = [];
        this.tempArrayList.forEach(element => {
          if (element.name) {
            if (element.name.toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
          if (element.code) {
            if (element.code.toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
        });
        if (val) {
          this.employeeData = tempArray;
        } else {
          this.employeeData = [...this.tempArrayList];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      //console.log("Org:", org);
      //console.log("Le ID", le);
      let bodyParams = {};
      let data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.itProofSubmissionValue = data.data.user.permissions.it_proof_submission ? true : false;
      //console.log("PL-3406", data);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";
.table-div {
  min-height: 350px;
  // max-height: 500px;
  margin-bottom: 175px;
  overflow: auto;
}
.add-btn-small {
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.employee-info {
  height: 150px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  padding: 20px 15px 20px 25px;
  position: relative;
  &:nth-child(n) {
    margin-right: 20px;
  }
  .btn-primary-small {
    background-color: white;
    color: $color-primary;
    border-radius: 4px;
    border: 1px solid $color-primary;
    height: 25px;
    padding: 0px 20px;
    font-size: $font-size-small;
    width: auto;
  }

  .header-text {
    font-size: 24px;
    font-weight: bold;
    color: $color-secondary;
  }
  .sub-text {
    font-size: 20px;
    color: $color-primary;
    margin-top: 20px;
  }
  .btn-upload {
    position: absolute;
    bottom: 20px;
    right: 15px;
  }
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.action-container {
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
}
.noData span {
  font-size: 18px;
  color: #858585;
}
.lineheight {
  height: 1px;
}

.selectdiv {
  select {
    max-width: 200px;
    border-radius: 4px;
    outline: 0;
    font-size: 14px;
    color: #9c9c9c;
    border: 1px solid #dadada;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* SVG background image */
    // background: url("@/assets/stroke-1.png");
    background-size: 12px;
    background-position: calc(100% - 10px) center;
    background-repeat: no-repeat;

    option {
      color: #9c9c9c;
      font-size: 12px;
    }
  }
}
a.anchor-underline-none {
  text-decoration: none;
}
.show-filter-block {
  position: absolute;
  transform: translate(-5%, -12%);
}

img.search-icon-filter {
  position: relative;
  right: 5px;
  top: 8px;
  width: 30px;
  height: 30px;
  // margin: 38px 6px 29px 32px;
  padding: 7px 4px 6px;
}
span.filter-text {
  font-weight: 600;
  color: #34c0be;
  font-size: 14px;
}

.filter-width {
  width: 390px;
}

.show-filter-block {
  position: absolute;
  transform: translate(-5%, -12%);
}

.download-block {
  position: absolute;
  width: 220px;
  transform: translate(-76%, -24%);
}

.grid-list-block {
  transform: translate(0%, -12%);
}

a.anchor-underline-none {
  text-decoration: none;
}

.line {
  width: 1px;
  height: 18px;
  margin: 0px 13px 0px 1px; //41px 13px 32px 15px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}

.model {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;

  span {
    color: #f3f3f3;
    font-size: xx-large;
  }
}

.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3b2867;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
